// local storage key for Store Selector MFE's selected store
export const SELECTED_STORE = 'PRIVATE_SSC_SELECTED_STORE';

// local storage key for Location Search MFE's search details
export const SEARCH_DETAILS = 'PRIVATE_SSC_SEARCH_DETAILS';
